import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Drawer, Tabs } from 'antd';
import styled from 'styled-components';

export const ChatDrawer = styled(Drawer)`
  direction: rtl;
  .ant-drawer-content-wrapper {
    width: 100% !important;
    min-width: 350px !important;
    max-width: 30% !important;
    background: red;
  }

  .ant-drawer-header {
    background: #ffffff;
    border-bottom: 1px solid #d0d0d0;

    .ant-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .ant-drawer-title {
      font-size: 20px;
      font-weight: ${FONT_WEIGHT.extremeBold};
      color: #1a295a;
    }

    .anticon.anticon-close {
      color: #1b2449;
    }
  }

  .ant-drawer-content {
    width: 100%;
  }

  .ant-drawer-body {
    padding: 0;
  }

  @media screen and (max-width: 1500px) {
    .ant-drawer-content-wrapper {
      max-width: 400px;
    }
  }
  @media screen and (max-width: 1025px) {
    .ant-drawer-title {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 620px) {
    .ant-drawer-content-wrapper {
      width: 100% !important;
      min-width: 100% !important;
      max-width: 100% !important;
      background: red;
    }
  }
`;

export const ChatWrapper = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  width: 100%;
  max-width: 100%;

  &.chat-layout {
    height: calc(100dvh - 290px);

    @media screen and (max-width: 1280px) {
      height: calc(100dvh - 220px);
    }
  }

  &.channel-info-layout {
    height: 100%;
    position: relative;
    padding-bottom: 100px;
  }
`;

export const TabsWrapper = styled(Tabs)`
  .ant-tabs-nav {
    background: #f5f5f5;
    border-bottom: 1.5px solid #1a295a;
    margin: 0;
  }

  .ant-tabs-tab {
    font-weight: ${FONT_WEIGHT.extremeBold};
    padding-block: 15px;
    margin-inline: 0 !important;
    flex: 1;
    justify-content: center;

    &:hover {
      color: #ce6239;
    }
  }

  .ant-tabs-ink-bar {
    background: #ce6239;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
  .ant-tabs-tab-active .ant-typography {
    color: #fff;
  }
  .ant-tabs-tab-active {
    background: #1a295a;
  }

  .ant-tabs-tab-btn {
    font-size: 16px;
    width: 100%;
    text-align: center;
  }

  .ant-tabs-nav-wrap {
    padding-inline: 0;

    &:before,
    &:after {
      display: none;
    }
  }

  .ant-tabs-nav-list {
    display: flex !important;
    width: 99%;
  }

  .ant-tabs-content .chat-messages {
    height: calc(100dvh - 210px);
    overflow-y: auto;

    &.chat-layout {
      height: calc(100dvh - 445px);

      @media screen and (max-width: 1280px) {
        height: calc(100dvh - 375px);
      }
    }
  }

  .channel-info-layout & {
    flex: 1;
    min-height: 0;

    .ant-tabs-content-holder {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }

    .ant-tabs-content,
    .ant-tabs-tabpane {
      height: 100%;
    }

    .ant-spin-nested-loading,
    .ant-spin-container {
      height: 100%;
    }

    .ant-tabs-content .chat-messages {
      height: 100%;
    }
  }

  @media screen and (max-width: 1025px) {
    .ant-tabs-nav-list {
      gap: 10px;
    }

    .ant-tabs-tab-btn {
      font-size: 13px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-inline: 8px;
`;

export const InputWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid #dcdcdc;
  background: #fff;
  width: 100%;
  position: absolute;
  bottom: 0;

  .ant-input {
    height: 46px;
    color: #243161;
    font-weight: ${FONT_WEIGHT.regular};

    &::placeholder {
      color: #243161;
      font-weight: ${FONT_WEIGHT.regular};
    }
  }
`;

export const ButtonIcon = styled.span`
  border: 1px solid #dcdcdc;
  padding-block: 0;
  background: #243161;
  width: 32px;
  height: 32px;
  margin-block: auto;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transform: rotate(180deg);

  &:has(> .disabled) {
    opacity: 0.5;
  }
}`;
